<!-- Layout page that can be used to create a HDN custom layout instead of the keycloak one -->
<template>
  <v-app id="inspire">
    <v-main class="grey lighten-3">
      <v-container>
        <v-sheet min-height="calc(100vh - 160px)" min-width="100%" rounded="lg">
          <router-view />
          <div class="pb-2 d-flex border-top">
            <v-spacer></v-spacer>

          </div>
        </v-sheet>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.border-top{
  border-top: thin solid rgba(0, 0, 0, 0.12);
}
</style>